module.exports = __webpack_public_path__ + "static/Raymond Chen.03273605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Raymond Chen.jpg
// module id = 1233
// module chunks = 6166952557895